import React, {useState} from 'react';
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import {Add, Delete} from "@mui/icons-material";
import * as PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import ColorPicker from "../../../components/colorPicker/ColorPicker";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

ColorPicker.propTypes = {
    onSubmit: PropTypes.func,
    open: PropTypes.bool
};

function AdminColorsParam({param, onChange, onDelete}) {
    const [open, setOpen] = useState(false);

    const addColor = (color) => {
        param.values = param.values || [];
        param.values.push({code: color});
        setOpen(false);
        onChange(param);
    }

    const deleteColor = (index) => {
        param.values.splice(index, 1);
        onChange(param);
    }

    const inputChange = (index, event) => {
        param.values[index].goToImgIndex = event.target.value;
        onChange(param);
    }

    const enableCustomColor = (event) => {
        param.props = param.props || {};
        param.props.customColorEnabled = event.target.checked;
        onChange(param);
    }

    return (
        <div>
            <Typography fontWeight={500} sx={{pb: 2}}>
                {param.key}
                <IconButton onClick={onDelete}><Delete/></IconButton>
            </Typography>
            <FormControlLabel
                key={"customColor"}
                control={<Checkbox onChange={enableCustomColor}
                                   checked={param?.props?.customColorEnabled}/>}
                label={'Enable custom color'}/>
            <Grid container className={"colors-param-container"} flexDirection={'column'}>
                {(param.values || []).map((color, index) => <Grid key={color.code} container alignItems={'center'}>
                    <Box sx={{
                        cursor: 'pointer',
                        border: '2px solid',
                        padding: '3px',
                        borderRadius: '50%',
                        borderColor: ('transparent')
                    }}>
                        <Paper sx={{width: '26px', height: '26px', backgroundColor: color.code, borderRadius: '50%'}}
                               elevation={2}/>
                    </Box>
                    <Box sx={{
                        position: 'absolute',
                        top: 5,
                        left: 5,
                        width: '26px',
                        height: '26px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <IconButton onClick={() => deleteColor(index)}>
                            <Delete fontSize={"small"}/>
                        </IconButton>
                    </Box>
                    Go to image:
                    <input type={'number'} onChange={event => inputChange(index, event)} value={color.goToImgIndex}/>
                </Grid>)}
                <Grid key={'add'}>
                    <Box sx={{
                        width: '31px',
                        height: '31px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>

                        <IconButton onClick={() => setOpen(!open)}>
                            <Add/>
                        </IconButton>
                        <ColorPicker onSubmit={addColor} open={open} onClose={() => setOpen(false)}/>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default AdminColorsParam;
